/**
 * Determines the correct fantasy route (EditTeam vs Points) based on game state.
 * 
 * Logic:
 * - No matches: redirect to new team creation
 * - Game ended (deadlineWeek is null but matches exist): Points
 * - Game not started or at deadline week: EditTeam
 * - Mid-game viewing past week: Points
 */
export function getFantasyRoute(
  teamId: string,
  deadlineInfo: { displayWeek: number | null; deadlineWeek: number | null; rosterEndWeek: number | null } | undefined,
  matchesExist: boolean
): string {
  // No matches found - should show error (handled elsewhere, default to new)
  if (!matchesExist) {
    return '/fantasy/new';
  }

  // Handle missing or invalid deadlineInfo
  if (!deadlineInfo) {
    return `/fantasy/edit/${teamId}`;
  }
  
  // Game ended: deadlineWeek is null but matches exist
  if (deadlineInfo.deadlineWeek === null && matchesExist) {
    return `/fantasy/points/${teamId}`;
  }
  
  // Game not started OR at deadline week (can edit): displayWeek >= deadlineWeek
  // This covers:
  // - deadlineWeek = 1 (game not started, displayWeek would also be 1 or null)
  // - Transfer periods when user is at the deadline week
  // - Last game week when deadlineWeek = rosterEndWeek
  if (deadlineInfo.deadlineWeek !== null && 
      (deadlineInfo.displayWeek === null || 
       deadlineInfo.displayWeek >= deadlineInfo.deadlineWeek)) {
    return `/fantasy/edit/${teamId}`;
  }
  
  // Mid-game viewing past week
  return `/fantasy/points/${teamId}`;
}
